import cx from "classnames"
import styles from "./DatePill.module.scss"

const DatePillField = ({ name, date, methods, className }) => {
  const { register } = methods

  return (
    <div className={cx(styles.datePill, className)}>
      <input
        className={cx(styles.input)}
        type="radio"
        value={date.date}
        {...register(name)}
      />
      <label className={styles.label}>{date.date_con}</label>
    </div>
  )
}

export default DatePillField
